export default __webpack_public_path__ + "static/media/email_workflow.37aed093.svg";